import { Layout } from '@/components/layout';
import { NotFoundPage } from '@/pages/not-found-page';
import { PaymentOptionsPage } from '@/pages/payment-options-page';
import { SupportPage } from '@/pages/support/support-page';
import { SystemErrorPage } from '@/pages/system-error-page';
import { PreprocessRootRedirect } from '@/pages/preprocess-root-redirect';
import { Route } from '@/util/react-router-dom';
import { MissingEmailPage } from '@/pages/auth/missing-email/missing-email-page';
import { SsoErrorPage } from '@/pages/sso-error-page';

/* Doesn't matter if the user is logged in or not */
export const publicRoutes = (
  <Route element={<Layout />}>
    <Route path="support" element={<SupportPage />} />
    <Route path="missing-email" element={<MissingEmailPage />} />
    <Route path="payment-options" element={<PaymentOptionsPage />} />
    <Route path="system-error" element={<SystemErrorPage />} />
    <Route path="sso-error" element={<SsoErrorPage />} />
    <Route path="not-found" element={<NotFoundPage />} />
    <Route path="*" element={<PreprocessRootRedirect to="/" replace />} />
  </Route>
);
